import React from 'react';
import {Box} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

import withState from '../../../../../utils/withState';
import {account$} from '../../../../../emitters/account';
import {LINK_DASHBOARD} from '../../../../../constants/links';
import {pushLocation} from '../../../../../router';

import FieldD from '../../../../dumb/Field/D';
import ReportDownload from '../../../../dumb/ReportDownload/B';
import {MerchantPageHeader} from '../../../../helpers/Display';

const AccountSection = withState(() => {
  return (state, props) => {
    const account = state.account || {};
    return (
      <div className={`cfx fx1 (w1/3|w1/2@m|w@m2|lt)>1 ` + (props.className || '')}>
        <FieldD
          label={account.company}
          value={(
            <div className="layoutRow fhaS fvaC">
              <div className="w185">{account.username}</div>
              <div>{account.country || '-'}</div>
            </div>
          )}
        />
      </div>
    );
  };
}, {
  account: account$,
});

module.exports = (props) => (
  <>
    <MerchantPageHeader
      title="Withdrawal details"
      backFN={() => {
        pushLocation({
          path: LINK_DASHBOARD + '?assetCode=' + props.assetCode
        })
      }}
      rightBlock={!!props.payments.length && (
        <ReportDownload
          className="pl10"
          urlPrefix="/v2/console/report-withdraw/"
          prefix="pbl"
          filter={{id: props.id}}
          disablePrint
        />
      )}
    />
    <Box mt="3.5rem">
      <AccountSection />
    </Box>
    <Box mt="3.5rem">
      <Divider />
    </Box>
  </>
)
